import * as React from "react";
import styles from "./PaymentMethodsBanner.module.scss";

/**
 * @component
 */
export function PaymentMethodsBanner(): React.ReactElement {
  const lang = `paymentcard-${document.body.dataset.lang || "en"}`;

  return (
    <div className={styles.wrapper}>
      <span className="svg svg-icon-paymentcard-paypal">&#160;</span>
      <span className="svg svg-icon-paymentcard-amazonpay">&#160;</span>
      <span className={`svg svg-icon-paymentcard-creditcard ${lang}`}>&#160;</span>
      <span className={`svg svg-icon-paymentcard-prepayment ${lang}`}>&#160;</span>
      <span className={`svg svg-icon-paymentcard-invoice ${lang}`}>&#160;</span>
    </div>
  );
}
